import { $ } from '@3pc/dom';
import { Accordion } from '@3pc/accordion';

const globalHeader = $('.global-header');

const initglobalHeader = () => {
  const breakpoint = 1200;
  // const randomID = uniqueId();

  // global-header button (burger, close)
  const handler = $('.navigation__button', globalHeader);

  // global-header navigation
  const target = $('.global-header__navigation', globalHeader);

  let AccordionInitted = false;

  const iniAccordion = () => {
    globalHeaderAccordion.init();
    AccordionInitted = true;
  };

  if (!handler || !target) return;

  // global-header BURGER
  const globalHeaderAccordion = new Accordion({
    target,
    handler,
    easing: 'easeInOutQuart',
    duration: 400,
    initOpened: false,
  });

  // init globalHeaderAccordion on resize if window width is bigger than breakpoint
  if (window.innerWidth < breakpoint) iniAccordion();

  window.addEventListener('resize', () => {
    if (window.innerWidth < breakpoint && !AccordionInitted) {
      return iniAccordion();
    }

    if (window.innerWidth >= breakpoint && AccordionInitted) {
      AccordionInitted = false;
      return globalHeaderAccordion.destroy();
    }
  });
};

const stickyScroll = () => {
  const activeClass = 'global-header--scrolled';
  const threshold = 80;

  if (
    document.body.scrollTop > threshold ||
    document.documentElement.scrollTop > threshold
  ) {
    globalHeader.classList.add(activeClass);
  } else {
    globalHeader.classList.remove(activeClass);
  }
};

if (globalHeader) {
  window.addEventListener('scroll', () => stickyScroll());
  initglobalHeader();
}
